// extracted by mini-css-extract-plugin
export default {"component":"FAQSection__component-uJSz","faqWrapper":"FAQSection__faqWrapper-xN11"};